import script from "./CustomerProductsOrdered.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerProductsOrdered.vue?vue&type=script&setup=true&lang=js"

import "./record/recordTable.css?vue&type=style&index=0&id=1a642e76&scoped=true&lang=css&external"
import "./CustomerProductsOrdered.vue?vue&type=style&index=1&id=1a642e76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a642e76"]])

export default __exports__

/* vue-cli-plugin-import-components */

import RecordTableCard from "@/components/customers/record/RecordTableCard.vue";
import ReportDateRangeFilter from "@/components/reports/ReportDateRangeFilter.vue";
script.components = Object.assign({}, { RecordTableCard, ReportDateRangeFilter }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { RecordTableCard, ReportDateRangeFilter }, script.__o.components);}